<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>CSQ Parent Consent</title>
    <style>
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      body {
        font-family: "Segoe UI", sans-serif;
        background-color: #171717;
      }

      .approval-card-container {
        min-height: 100vh;
        padding: 1.5rem;
        position: relative;
        width: 100%;
        background-color: #171717;
        /* background-image: url("login-bgVideo.gif"); */
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        overflow-y: auto;
      }

      .container-card {
        background-color: #171717;
        border-radius: 0.313rem;
        display: grid;
        height: fit-content;
        max-width: 940px;
        width: 100%;
        margin: auto;
      }

      .logo-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .logo-banner {
        width: 100%;
        height: auto;
      }

      .logo {
        width: 100%;
        height: auto;
        max-width: 130px;
        display: block;
        margin: 0 auto;
      }

      .body {
        padding: 1.5rem;
        min-height: 50vh;
      }

      .spinner-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-height: 50vh;
      }

      .spinner {
        border: 3px solid rgba(255, 255, 255, 0.3);
        border-top: 3px solid #ffffff;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        animation: spin 1s linear infinite;
        margin: auto;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }

      .heading-text,
      p {
        font-size: 14px;
        line-height: 24px;
        color: #fff;
      }

      h3.heading-text {
        font-size: 18px;
        margin-bottom: 0.75rem;
      }

      h4.heading-text {
        font-size: 15px;
        margin-bottom: 0.5rem;
      }

      .bold {
        font-weight: 600;
      }

      p {
        margin-bottom: 0.5rem;
      }

      ol {
        padding: 0;
        margin-bottom: 1rem;
      }

      ol li {
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        margin-left: 15px;
        line-height: 24px;
      }

      .bit-container {
        border: 1px solid #b45f9e;
        background-color: #2f222c;
        border-radius: 5px;
        padding: 12px;
        margin-bottom: 0.5rem;
      }

      .btn-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 2rem;
      }

      .rew-button {
        background-color: #2cc3e8;
        border-radius: 5px;
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: none;
        padding: 8px 20px;
        cursor: pointer;
        transition: opacity 0.2s;
      }

      .rew-button:hover {
        opacity: 0.8;
      }

      .footer-section {
        display: grid;
        align-items: center;
        justify-content: center;
        padding: 1.5rem;
        margin-top: 1rem;
        border-top: 1px solid #959595;
      }

      .mascot-container {
        width: 100%;
        display: grid;
        justify-items: center;
        gap: 1rem;
        margin: 1rem 0;
      }

      .mascot-img-content {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        gap: 1rem;
      }

      .mascot-icon-wrapper {
        border-radius: 50rem;
        transition:
          background-color 0.3s ease,
          transform 0.3s ease;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px;
      }

      .mascot-icon {
        width: 2rem;
        height: 2rem;
        object-fit: contain;
      }

      .mascot-icon-wrapper.tiktok:hover {
        background-color: #69c9d0;
        transform: scale(1.1);
      }

      .mascot-icon-wrapper.instagram:hover {
        background: linear-gradient(to right, #833ab4, #fd1d1d, #fcb045);
        transform: scale(1.1);
      }

      .mascot-icon-wrapper.facebook:hover {
        background-color: #3b5998;
        transform: scale(1.1);
      }

      .mt-3 {
        margin-top: 1rem;
      }
    </style>
  </head>
  <body>
    <div class="approval-card-container">
      <div class="container-card">
        <!-- Logo Banner -->
        <div class="logo-container">
          <img
            src="https://web-trex-dev-api.azurewebsites.net/assets/images/email-temp-logo.png"
            alt="CSQ Logo"
            class="logo-banner"
          />
        </div>

        <!-- Loading Spinner (hidden by default, add class "visible" to show) -->
        <!-- 
    <div class="spinner-wrapper">
      <div class="spinner"></div>
    </div>
    -->

        <!-- Main Body -->
        <div class="body">
          <div>
            <h3 class="heading-text">
              Hi
              <span class="bold">{{ studentData?.parentGuardianFullName }}</span
              >,
            </h3>

            <p>
              Construction Skill Queensland (CSQ) is partnering with Schools in
              Queensland to offer students an opportunity to participate in its
              Construction Pathways program. This is being facilitated through
              the CSQ Construction Pathways Experience Portal, where students
              will be required to set up individual accounts with the consent of
              their parent(s) or guardian(s).
            </p>
            <p>
              [Student Name] has expressed interest in participating and is
              accordingly required to registering for through the CSQ
              Construction Pathways Experience Portal on behalf of [School].
              Your consent is required for the creation of the student's account
              for legal and privacy reasons. Your consent will allow CSQ to
              securely collect, store, manage and use the student's personal
              information in various forms of media.
            </p>
          </div>

          <div>
            <h3 class="heading-text bold">
              What are the benefits of the Construction Pathways Experience
              Portal?
            </h3>
            <ol>
              <li>
                This portal allows their construction-related activities both
                through CSQ Construction Pathways and their school to be
                recorded to create a CV for future opportunities.
              </li>
              <li>
                It opens opportunities for engaging with the construction
                industry to help them with their future career.
              </li>
              <li>
                Have visibility of our upcoming free school partnered events and
                opportunities.
              </li>
            </ol>

            <div class="bit-container">
              <h4 class="heading-text bold">
                A bit more about Construction Pathways
              </h4>
              <p>
                Our Construction Pathways Program is supported by Construction
                Skills Queensland (CSQ) and forms part of the Gateway to
                Industry Schools Project (GISP), proudly supported and funded by
                the Queensland Government. We deliver safe, structured, and
                engaging programs that help students explore careers in the
                construction industry.
              </p>
              <p>
                Our programs include hands-on Try a Trade activities, site
                tours, virtual reality experiences, and interactive workshops,
                providing insight into both trade and professional roles.
              </p>
              <p>
                All activities are delivered in partnership with schools and
                industry, supervised by trained staff, and operate under strict
                safety protocols. PPE is provided for all site-based events.
              </p>
            </div>

            <p>
              Click the button below to proceed with reviewing the student's
              information and provide consent to the creation of the students
              account in the CSQ Construction Pathways Experience Portal and the
              use of the student's information (image, sound recording, or name)
              under the Privacy Act 1988 (Cth).
            </p>

            <div class="btn-wrapper">
              <a
                href="/parent-approval/media-consent?token={{token}}"
                target="_blank"
                style="
                  background-color: #2cc3e8;
                  border-radius: 5px;
                  color: #ffffff;
                  font-size: 16px;
                  font-weight: 500;
                  display: inline-block;
                  border: none;
                  padding: 8px 20px;
                  text-decoration: none;
                "
              >
                Review to Approve or Decline Student Registration
              </a>
            </div>

            <p class="mt-3">
              If no action is taken, your child's information will remain in
              Pending Parent Consent Status and will be removed after 7 days.
            </p>

            <p class="mt-3">
              If you have any questions or need help, don't hesitate to speak
              with [Teacher] at [School] or contact us by replying to this
              email.
            </p>

            <p class="mt-3">Thank you,<br />CSQ Construction Pathways Team</p>

            <!-- Footer -->
            <div class="footer-section">
              <img
                src="assets/images/Logo/login-logo.svg"
                alt="CSQ Logo"
                class="logo"
              />

              <div class="mascot-container">
                <div class="mascot-img-content">
                  <a
                    href="https://www.tiktok.com/@constructionpathways"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div class="mascot-icon-wrapper tiktok">
                      <img
                        src="assets/images/tiktok-logo.svg"
                        alt="tiktok"
                        class="mascot-icon"
                      />
                    </div>
                  </a>

                  <a
                    href="https://www.instagram.com/constructionpathways/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div class="mascot-icon-wrapper instagram">
                      <img
                        src="assets/images/instagram-logo.svg"
                        alt="instagram"
                        class="mascot-icon"
                      />
                    </div>
                  </a>

                  <a
                    href="https://www.facebook.com/constructionpathways"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div class="mascot-icon-wrapper facebook">
                      <img
                        src="assets/images/facebook-logo.svg"
                        alt="facebook"
                        class="mascot-icon"
                      />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</html>
